import { render, staticRenderFns } from "./ListVSDetail.vue?vue&type=template&id=13cb6946"
import script from "./ListVSDetail.vue?vue&type=script&lang=js"
export * from "./ListVSDetail.vue?vue&type=script&lang=js"
import style0 from "./ListVSDetail.vue?vue&type=style&index=0&id=13cb6946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports